import React from "react";
import { Edit3, ChevronDown } from "lucide-react";
import Dropdown from "../../../components/Dropdown";
import { TextField, DropdownField, SpinnerField, TextareaField } from "./FormFields";
import styles from "../css/inventoryItemDetail.module.css";

export const ClinicLayout = ({
  data,
  qty,
  setQty,
  reorder,
  setReorder,
  packSize,
  setPackSize,
  icdDisplay,
  setShowIcdModal,
  expiryDisplay,
  hasMultipleExpiry,
  setShowExpiryModal,
  category,
  setCategory,
  customCategory,
  setCustomCategory,
  categoryOptions,
  hideDrugFields,
  readOnly = false,
}) => {
  return (
    <>
      {/* Clinic layout matching image */}
      {/* Row 1: Nappi Code, SKU, Active ingredient, Strength, ICD-10, Quantity */}
      <div className={styles.row}>
        <TextField label="Nappi Code" value={data.nappi} readOnly />
        <TextField label="SKU" value={data.sku} readOnly />
        {!hideDrugFields && <TextField label="Active ingredient" value={data.ingredient} readOnly />}
        {!hideDrugFields && (
          <DropdownField
            label="Strength"
            options={["250mg", "500mg", "1g"]}
            value={data.strength}
            readOnly={readOnly}
          />
        )}
        {!hideDrugFields && (
          <div className={styles.field}>
            <div className={styles.icdLabelRow}>
              <label>ICD-10</label>
              {!readOnly && (
              <button
                type="button"
                className={styles.icdEditBtn}
                onClick={() => setShowIcdModal(true)}
                aria-label="Edit ICD-10"
              >
                <Edit3 size={16} />
              </button>
              )}
            </div>
            <div
              className={styles.icdDisplay}
              role={readOnly ? undefined : "button"}
              tabIndex={readOnly ? -1 : 0}
              onClick={readOnly ? undefined : () => setShowIcdModal(true)}
              onKeyDown={readOnly ? undefined : (e) => (e.key === 'Enter' || e.key === ' ') && setShowIcdModal(true)}
              aria-label={readOnly ? undefined : "Open ICD-10 editor"}
            >
              <input
                type="text"
                value={icdDisplay}
                readOnly
                className={styles.icdReadonlyInput}
                aria-label="Selected ICD-10 codes"
              />
              <span className={styles.icdCaret} aria-hidden>
                <ChevronDown size={16} />
              </span>
            </div>
          </div>
        )}
        <SpinnerField
          label="Quantity"
          value={qty}
          onChange={readOnly ? undefined : setQty}
          min={0}
          step={1}
          ariaLabel="Quantity"
          readOnly={readOnly}
        />
      </div>

      {/* Row 2: Schedule, Expiry Date, Pack Size, Dosage Form, Reorder Level, Cost Price, Bin Number */}
      <div className={styles.row}>
        {!hideDrugFields && <TextField label="Schedule" value={data.schedule} readOnly />}
        <div className={styles.field}>
          <label>Expiry Date</label>
          <input type="text" value={data.expiry} readOnly />
        </div>
        <SpinnerField
          label="Pack Size"
          value={packSize}
          onChange={readOnly ? undefined : setPackSize}
          min={0}
          step={1}
          ariaLabel="Pack Size"
          readOnly={readOnly}
        />
        {!hideDrugFields && (
          <DropdownField
            label="Dosage Form"
            options={["Tablets", "Capsules", "Pills", "Syrup", "Injection"]}
            value={data.dosageForm}
            readOnly={readOnly}
          />
        )}
        <SpinnerField
          label="Reorder Level"
          value={reorder}
          onChange={readOnly ? undefined : setReorder}
          min={0}
          step={1}
          ariaLabel="Reorder Level"
          readOnly={readOnly}
        />
        <TextField label="Cost Price" value={data.costPrice} readOnly />
        <DropdownField
          label="Bin Number"
          options={["Clinic Storage", "Warehouse A, Shelf 101", "Warehouse B, Shelf 15"]}
          value={data.binNumber}
          readOnly={readOnly}
        />
      </div>

      {/* Row 3: Supplier, Supplier code, Invoice Number, Last Reorder */}
      <div className={styles.row}>
        <TextField label="Supplier" value={data.supplier} readOnly />
        <TextField label="Supplier code" value={data.supplierCode} readOnly />
        <TextField label="Invoice Number" value={data.invoiceNumber} readOnly />
        <TextField label="Last Reorder" value={data.lastReorder} readOnly />
      </div>

      {/* Category (short) above Notes */}
      <div className={styles.row}>
        <div className={styles.field}>
          <label>Category</label>
          <div className={styles.categoryFieldRow}>
            <div className={styles.categorySelectWrap}>
              {readOnly ? (
                <input type="text" value={category} readOnly />
              ) : (
                <Dropdown
                  options={categoryOptions}
                  value={category}
                  onChange={(val) => {
                    setCategory(val);
                    if (val !== "Other") setCustomCategory("");
                  }}
                />
              )}
            </div>
            {!readOnly && category === "Other" && (
              <input
                className={styles.categoryOtherInput}
                type="text"
                value={customCategory}
                onChange={(e) => setCustomCategory(e.target.value)}
                placeholder="Enter category"
              />
            )}
          </div>
        </div>
      </div>

      {/* Notes */}
      <div className={styles.row}>
        <TextareaField label="Note" value={data.note} full readOnly />
      </div>
    </>
  );
};
